import { RevokeStorefrontSessionsResponse, StorefrontBannerListResponse, StorefrontBannerResponse, StorefrontMenuResponse, StorefrontListResponse, StorefrontMetricsResponse, StorefrontResponse, StorefrontSessionsResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/storefront-admin` — a loja online da conta (F221, ADR-0041).
 *
 * É a tela que configura; o que o site de atacado chama é
 * `/api/v1/storefront/<endereço>/...`, e não passa por aqui.
 */
export const fetchStorefronts = async (signal) => StorefrontListResponse.parse(await request('/api/v1/storefront-admin', { signal }));
export const createStorefront = async (input) => StorefrontResponse.parse(await request('/api/v1/storefront-admin', { method: 'POST', body: input }));
export const updateStorefront = async (id, input) => StorefrontResponse.parse(await request(`/api/v1/storefront-admin/${id}`, {
    method: 'PUT',
    body: input,
}));
export const fetchStorefrontSessions = async (id, signal) => StorefrontSessionsResponse.parse(await request(`/api/v1/storefront-admin/${id}/sessions`, { signal }));
export const revokeStorefrontSessions = async (id, partyId) => RevokeStorefrontSessionsResponse.parse(await request(`/api/v1/storefront-admin/${id}/sessions/${partyId}/revoke`, {
    method: 'POST',
    body: {},
}));
/** As métricas da loja num período de dias de São Paulo (F226). */
export const fetchStorefrontMetrics = async (id, period, signal) => StorefrontMetricsResponse.parse(await request(`/api/v1/storefront-admin/${id}/metrics?from=${period.from}&to=${period.to}`, { signal }));
const bannersOf = (storefrontId) => `/api/v1/storefront-admin/${storefrontId}/banners`;
export const fetchStorefrontBanners = async (storefrontId, signal) => StorefrontBannerListResponse.parse(await request(bannersOf(storefrontId), { signal })).banners;
export const createStorefrontBanner = async (storefrontId, input) => StorefrontBannerResponse.parse(await request(bannersOf(storefrontId), { method: 'POST', body: input })).banner;
export const updateStorefrontBanner = async (storefrontId, bannerId, input) => StorefrontBannerResponse.parse(await request(`${bannersOf(storefrontId)}/${bannerId}`, {
    method: 'PATCH',
    body: input,
})).banner;
/** Multipart sem `Content-Type` à mão: quem monta a fronteira é o `FormData`. */
export const uploadStorefrontBannerImage = async (storefrontId, bannerId, slot, file) => {
    const form = new FormData();
    form.append('file', file);
    return StorefrontBannerResponse.parse(await request(`${bannersOf(storefrontId)}/${bannerId}/image/${slot}`, {
        method: 'POST',
        body: form,
    })).banner;
};
export const removeStorefrontBannerMobileImage = async (storefrontId, bannerId) => StorefrontBannerResponse.parse(await request(`${bannersOf(storefrontId)}/${bannerId}/image/mobile`, {
    method: 'DELETE',
})).banner;
export const reorderStorefrontBanners = async (storefrontId, ids) => StorefrontBannerListResponse.parse(await request(`${bannersOf(storefrontId)}/order`, {
    method: 'PUT',
    body: { ids },
})).banners;
export const deleteStorefrontBanner = async (storefrontId, bannerId) => {
    await request(`${bannersOf(storefrontId)}/${bannerId}`, { method: 'DELETE' });
};
export const fetchStorefrontMenu = async (storefrontId, signal) => StorefrontMenuResponse.parse(await request(`/api/v1/storefront-admin/${storefrontId}/menu`, { signal })).categories;
export const saveStorefrontMenu = async (storefrontId, input) => StorefrontMenuResponse.parse(await request(`/api/v1/storefront-admin/${storefrontId}/menu`, {
    method: 'PUT',
    body: input,
})).categories;
//# sourceMappingURL=storefront.js.map